@if (!isEditMode) {
<span [class]="getContainerDisplayClasses(status)" [title]="getStatusDisplay(status)">
  <i class="mr-1" [class]="getStatusIcon(status)"></i>
  <span [class]="getDisplayClasses(status)">
    {{ getStatusDisplay(status) | translate }}
  </span>
</span>
} @else {
<span (click)="onClick()"
  [class]="getContainerDisplayClasses(status) + ' cursor-pointer'">
  <i class="mr-1" [class]="getStatusIcon(status)"></i>
  <span [class]="getDisplayClasses(status)">
    {{ getStatusDisplay(status) | translate }}
  </span>
  <button type="button" *ngIf="deleteButton"
    (click)="deleteButtonClicked.emit()"
    class="ml-1 text-blue-600 hover:text-blue-800 focus:outline-none absolute right-2 top-1/2 -translate-y-1/2">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
    </svg>
  </button>
</span>
}